import { render } from "./LoanHistoryResendDialog.vue?vue&type=template&id=1a61a529"
import script from "./LoanHistoryResendDialog.vue?vue&type=script&lang=js"
export * from "./LoanHistoryResendDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__